import "lodash";
import axios from "axios";
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/datepicker';
import {draggableElement} from "./broker/poc";
import { displayCheckedBoxes, emailAttachmentDragDrop, } from "./emailNotificationsScript.js";

function showCoiReqDialog (title, status, contractor_id) {

    window.analyticsModule.trackEvent({
        name: 'ctr_dashboard_viewcoi',
        type: 'Action'
    })

    let titleClass = status.toLowerCase()
    if (status === 'Inactive') {
        titleClass = 'archived'
    }
    document.getElementById('coi-form-title').innerHTML = title + "" +
        "<span class=\" " + titleClass + "-status ml-2 py-1 px-4 \">" + status + "</span>" +
        "<a href=\"#\"\n" +
        "                           data-dismiss=\"modal\"\n" +
        "                           class=\"btn move-right\"><i class=\"fa fa-times font-29\" aria-hidden=\"true\"></i></a>"
    document
        .getElementById('edit-contractor')
        .setAttribute('href', "/update/existing/contractor?id=" + contractor_id);
    $("#coi-settings").modal('show')
}

function newPartner () {
    window.analyticsModule.trackEvent({name: 'pm_addpartners_another', type: 'Action'})
    let children = document.getElementById('partners').children
    let length = children.length + 1
    let new_div_id = 'p-' + length
    let new_div = document.createElement('div')
    new_div.setAttribute('id', new_div_id)
    document.getElementById('partners').appendChild(new_div)
    axios.get('/add/contractors/blade', {
        params: {
            id: length - 1
        }
    }).then(function (resp) {
        document.getElementById(new_div_id).innerHTML = resp.data.html
        addDatePicker('contractor-' + (length - 1) + '-datepicker-0')
        certificateDragDrop(length - 1)
    }).catch(function () {
        alert('Unknown Server Error occurred');
    })
}

function removeNewPartner () {

}

export function validateUploadedFile (file, file_name, event) {
    let size = file['size'] / (1024 * 1024)
    let splitted_name = file_name.split('.')
    let extension = splitted_name[splitted_name.length - 1].toLowerCase()
    let error_modal_element = document.getElementById('error-modal')
    if (size > 2) {
        if (error_modal_element) {
            $("#error-modal").modal('show')
            document.getElementById('error-title').innerHTML = 'File Size Error'
            document.getElementById('error-body').innerHTML = 'File size must be less than 2 MB'
        }
        if (event)
            event.target.value = ""
        return false
    } else if (extension !== 'txt' && extension !== 'doc' && extension !== 'docx' && extension !== 'pdf') {
        if (error_modal_element) {
            $("#error-modal").modal('show')
            document.getElementById('error-title').innerHTML = 'File Extension Error'
            document.getElementById('error-body').innerHTML = 'File type not accepted, only txt, doc, docx and pdf files are allowed'
        }
        if (event)
            event.target.value = ""
        return false
    }
    return true
}

function loadCertificate (event, id) {
    let file = event.target.files[0]
    uploadCertificate(file, id, event)
}

function showContactDeleteConfirmation (id) {
    window.analyticsModule.trackEvent({name: 'ctr_dashboard_deleteptr', type: 'Action'})
    document.getElementById('deleted-contractor-id').value = id
    $("#delete-contractor").modal('show')
}

function deletePolicy (policy_id, policy_db_id) {
   
    document.getElementById(policy_id).remove()
   
    if (policy_db_id) {
        axios.delete('/delete/policy', {
            params: {
                id: policy_db_id
            }
        })
    }
}
function policyDelete (policy_id,id,contractor_id)
{
    document.getElementById('add-policy').disabled=false;
    document.getElementById("add-policy").style.cursor="pointer";
    document.getElementById(policy_id).remove();
}

function deleteContractor () {
    $("#delete-contractor").modal('hide')
    let id = document.getElementById('deleted-contractor-id').value
    axios.delete('/delete/contractor', {
        params: {
            id: id
        }
    }).then(function (resp) {
        if (resp.data.status) {
            window.location.reload()
        } else {
            alert('Error occurred while deleting contractor')
        }
    }).catch(function () {
        alert('Error occurred while deleting contractor')
    })
}

function sendReminder () {
    let contractorId = document.getElementById('reminder-contractor-id').value
    let policyId = document.getElementById('reminder-policy-id').value
    let send_reminder_buttons = document.getElementById('send-reminder-buttons')
    let send_reminder_messages_element = document.getElementById('send-reminder-messages')
    send_reminder_buttons.classList.add('d-none')
    send_reminder_messages_element.innerHTML = 'Sending reminder please wait ...'
    send_reminder_messages_element.classList.remove('d-none')
    $.ajax({
        url: '/contractor/send_reminder',
        type: 'get',
        data: {
            contractorId: contractorId,
            policyId: policyId,
        },
        dataType: 'json',
        success: function (data) {
            if (data.success) {
                send_reminder_messages_element.innerHTML = 'Reminder successfully sent'
                setTimeout(function () {
                    $("#send-reminder").modal('hide')
                    send_reminder_buttons.classList.remove('d-none')
                    send_reminder_messages_element.classList.add('d-none')
                }, 1000);
            }
        }
    });
}

function sendReminderConfirmation (contractor_id, policy_id) {
    window.analyticsModule.trackEvent({name: 'ctr_dashboard_sendremdr', type: 'Action'})
    document.getElementById('reminder-contractor-id').value = contractor_id
    document.getElementById('reminder-policy-id').value = policy_id
    $("#send-reminder").modal('show')
}

function addDatePicker (id, date) {
  
    if (!date) {
        let today = new Date()
         
        let month = today.getMonth() + 1
        if (month < 10) {
            month = '0' + month
        }
        let day = today.getDate()
        if (day < 10) {
            day = '0' + day
        }
        date = month + '/' + day + '/' + today.getFullYear()
    }
    let min_date=new Date()
    min_date.setFullYear( min_date.getFullYear() - 1 ); 
    if(!document.getElementById(id)) return
    $('#' + id).datepicker({showRightIcon: false, header: true, format: 'mm/dd/yyyy',minDate:min_date}).value(date);
}
function emptyDatePicker (id)
{
    let min_date=new Date()
    min_date.setFullYear( min_date.getFullYear() - 1 ); 
    if(!document.getElementById(id)) return
    $('#' + id).datepicker({showRightIcon: false, header: true, format: 'mm/dd/yyyy',minDate:min_date});
    expired_value(id);
}
function addNewPolicy (duplicate, id, contractor_id,type) {
    document.getElementById('add-policy').disabled=true;
    document.getElementById("add-policy").style.cursor="no-drop";
    var children = document.getElementById(contractor_id + '-policies').children;
    var next_id = 0;
    if (children.length > 0) {
      var splitted_id = children[children.length - 1].id.split('-');
      next_id = parseInt(splitted_id[splitted_id.length - 1]) + 1;
    }
    var new_div_id = contractor_id + '-policy-' + next_id;
    var new_div = document.createElement('div');
    new_div.setAttribute('id', new_div_id);
   var policy_type = null;
    var effective_date = null;
    if (duplicate) {
      policy_type = document.getElementById(contractor_id + '-type-' + id).value;
      effective_date = document.getElementById(contractor_id + '-datepicker-' + id).value;
    }
   document.getElementById(contractor_id + '-policies').appendChild(new_div);
    axios.get('/add/policy/blade', {
      params: {
        id: next_id,
        policy_type: policy_type,
        effective_date: effective_date,
        contractor_id: contractor_id,
        new_div_id: new_div_id,
        page:type,
      }
    }).then(function (resp) {
        let prev_id=next_id-1;
    
     new_div.setAttribute('class', "add-policy-div");
      document.getElementById(new_div_id).innerHTML = resp.data.html;
      addDatePicker(contractor_id + '-datepicker-' + next_id, effective_date);
    
      if(type=="edit")
      {
        $('#addPolicyModal-'+prev_id+'').modal('hide');   
            if(document.getElementById('new_certificate_id').value == "")
          {
            $('#addPolicyModal-'+next_id+'').modal('show');
            $(".add-policy-div").addClass("after_modal_appended");
            $(".modal-backdrop").appendTo(".add-policy-div");
            $("body").removeClass("modal-open");
            $("body").css("padding-right", "");
        }
    }
    dropdown_policies(next_id,resp.data.type);
    })
};
function addnewpolicytype (id){
    var contractor_id=document.getElementById("contractor_id").value;
    var children = document.getElementById(contractor_id + '-policies').children;
    var new_div_id= contractor_id + '-policy-' + id;
    var type=document.getElementById("new_type").value;
    if(type != "")
    {
        axios.get('/add/policy/blade', {
            params: {
                id:id,
                type:type,
                contractor_id: contractor_id,
                new_div_id: new_div_id,
            }
        })
        .then(function (resp) {
            for( var i=0; i<children.length; i++ )
            {
                var option = document.createElement("option");
                option.text = resp.data.new_type.name;
                option.value = resp.data.new_type.id;
                var select = document.getElementById(contractor_id+'-type-'+ i);
                select.appendChild(option);
            }
            $('#testmodal').modal('hide');
        });
    } else {
        var error=document.getElementById("type_error").style.display="block";
    }
}

function addnewpolicytypeonedit (policies){
    var contractor_id=document.getElementById("contractor_id").value;
    var type=document.getElementById("new_type").value;
    if(type != "")
    {
            var policies= JSON.parse(policies);
    axios.get('/add/policy/blade', {
    params: {
        
    type:type,
    contractor_id: contractor_id,
    
    }    
    }).then(function (resp) {
        for(var i=0; i<policies.length;i++)
        {
            
        var option = document.createElement("option");
        option.text = resp.data.new_type.name;
        option.value = resp.data.new_type.id;
        var select = document.getElementById(contractor_id+'-type-'+i );
        select.appendChild(option);
        }
        $('#testmodal').modal('hide');
        
    });
}
else{
    var error=document.getElementById("type_error").style.display="block";
}

}
$(document).ready(function(){
    var show_btn=$('.show-modal');
    var show_btn=$('.show-modal');
    //$("#testmodal").modal('show');
      show_btn.click(function(){
        $("#testmodal").modal('show');
        var error=document.getElementById("type_error").style.display="none";
    })
});

$(function() {
    $('#element').on('click', function( e ) {
        Custombox.open({
            target: '#testmodal-1',
            effect: 'fadein'
        });
        e.preventDefault();
    });
});

function changeContractorStatus (id, status) {
    axios.post('/update/contractor', {
        id,
        status,
        type: document.getElementById('contractor-type').value
    }).then(function (resp) {
       if(resp.data.status=="I" || resp.data.status=="V")
       {
          document.getElementById("active-status-link-"+resp.data.id).style.display="none";
        var html ='<div class="data-dropdown pb-2" ><div class="dropdown show"> <p class="archived-status py-1 m-0 remove-text-decoration" id="archived-status-link-'+resp.data.id+'"  data-mdb-toggle="dropdown" aria-expanded="false" data-toggle="dropdown" >'  
        html+= '  <a  role="button"  > <span class="d-none">Status </span>Inactive </a>'
        html+='<div class="dropdown-menu  status-dropdown"  aria-labelledby="archived-status-link-'+resp.data.id+'">'
         html+='<p class="dropdown-status py-1 remove-text-decoration"  id="active-status-'+resp.data.id+'" >'  
        html+= '<a   onclick="changeContractorStatus('+resp.data.id+','+"'A'"+')" role="button"   >'
        html+=  '<span class="d-none">Status </span>Active </a> </p>'
        html+='<p class="dropdown-status py-1 remove-text-decoration"  id="active-status-'+resp.data.id+'"  >'
        html+= '<a  onclick="delete_contractor('+resp.data.id+')"  role="button"  >'
        html+= '<span class="d-none">Status </span>Delete</a></p>'
        html+='</div> </div> </div>'
        document.getElementById('status-dropdown-'+resp.data.id).innerHTML=html;
      
        }
        else if(resp.data.status=="A")
        {
        document.getElementById("archived-status-link-"+resp.data.id).style.display="none";
        var html ='<div class="data-dropdown pb-2" ><div class="dropdown show"><p class="active-status py-1 m-0 remove-text-decoration" id="active-status-link-'+resp.data.id+'"  data-mdb-toggle="dropdown" aria-expanded="false" data-toggle="dropdown"> '  
        html+= '<a  role="button"   >'
        html+=  '<span class="d-none">Status </span>Active </a> </p>'
        html+=' <div class="dropdown-menu  status-dropdown"  aria-labelledby="active-status-link-'+resp.data.id+'">'
        html+='<p class="dropdown-status py-1 remove-text-decoration"  id="archived-status-'+resp.data.id+'" >'  
        html+= '<a   onclick="changeContractorStatus('+resp.data.id+','+"'I'"+')" role="button"   >'
        html+=  '<span class="d-none">Status </span>Inactive </a> </p>'
        html+=' <p class="dropdown-status py-1 remove-text-decoration"  id="archived-status-'+resp.data.id+'">'
        html+='<a  onclick="delete_contractor('+resp.data.id+')"  role="button"  >'
        html+= '<span class="d-none">Status </span>Delete</a> </p>'
        html+='</div></div></div>'
        document.getElementById('status-dropdown-'+resp.data.id).innerHTML=html;
      
        }
    })
}

function validatePartnerCreationForm () {
    let total_contractors = document.getElementById('partners').children.length
    let total_policies= document.getElementById('contractor-0-policies').children.length;
    let error_title = 'Missing required field'
    let error_title_element = document.getElementById('error-title')
    let error_title_body = document.getElementById('error-body');
    error_title_body.innerHTML = ""
    let form_completed = true
    for (let i = 0; i < total_contractors; i++) {
        let contractor_number = total_contractors > 1 ? (' for contractor ' + (i + 1)) : '';
        if (document.getElementById('name-company-' + i).value === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Company name is missing' + contractor_number + '<br>'
            form_completed = false
        }
        if (document.getElementById('name-contact-' + i).value === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Contact name is missing' + contractor_number + '<br>'
            form_completed = false
        }
        let contact_email = document.getElementById('email-contact-' + i).value
        if (contact_email === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Contact email is missing' + contractor_number + '<br>'
            form_completed = false
        } else {
            if (!validateEmail(contact_email)) {
                error_title_body.innerHTML += 'Contact email is invalid' + contractor_number + '<br>'
                form_completed = false
            }
        }
        if (!document.getElementById('certificate-' + i).value ||
            document.getElementById('certificate-' + i).value === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'No certificate uploaded' + contractor_number + '<br>'
            form_completed = false
        }
        if (document.getElementById('name-producer_company-' + i).value === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Insurance Company Name' + contractor_number + '<br>'
            form_completed = false
        }
        if (document.getElementById('name-producer-' + i).value === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Insurance Contact Name' + contractor_number + '<br>'
            form_completed = false
        }
        let contact_company_email = document.getElementById('email-insurance_contact-' + i).value
        if ( contact_company_email=== "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Insurance Contact Email' + contractor_number + '<br>'
            form_completed = false
        } else {
            if (!validateEmail(contact_company_email)) {
                error_title_body.innerHTML += 'Insurance Contact Email is invalid' + contractor_number + '<br>'
                form_completed = false
            }
        }
        let phone_no=document.getElementById('phone-insurance_contact-'+i).value;
        if (phone_no === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Insurance Phone Number' + contractor_number + '<br>'
            form_completed = false
        }
        else{
            if(!validatePhone(phone_no))
            {
                error_title_body.innerHTML += 'Insurance Contact Number is invalid' + contractor_number + '<br>'
                form_completed = false
            }
        }

        if(document.getElementById('add-policy-table').children.length == 0)
        {
        error_title_body.innerHTML += 'Policy is Required'+'<br>'
        form_completed = false;

        }
    }
    
    
    if (form_completed) {
        document.getElementById('contractor-0-policies').remove();
        confirmSubscriptionUpdate(total_contractors)
    } else {
        $("#error-modal").modal('show')
    }
}
function validateTenantCreationForm () {
      let error_title = 'Missing required field'
    let error_title_element = document.getElementById('error-title')
    let error_title_body = document.getElementById('error-body');
    error_title_body.innerHTML = ""
    let form_completed = true
  
        if (document.getElementById('name-company').value === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Company name is missing'+ '<br>'
            form_completed = false
        }
        if (document.getElementById('tenant-phone').value === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Tenant Phone No is missing' + '<br>'
            form_completed = false
        }
        let contact_email = document.getElementById('email-contact').value
        if (contact_email === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Contact email is missing' + '<br>'
            form_completed = false
        } else {
            if (!validateEmail(contact_email)) {
                error_title_body.innerHTML += 'Contact email is invalid' + contractor_number + '<br>'
                form_completed = false
            }
        }
        if(document.getElementById('tenant-address').value === "")
        {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Tenant Address is missing' + '<br>'
            form_completed = false
        }
        if (document.getElementById('name-producer_company').value === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Insurance Company Name'+ '<br>'
            form_completed = false
        }
        if (document.getElementById('name-producer').value === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Insurance Contact Name' + '<br>'
            form_completed = false
        }
        let contact_company_email = document.getElementById('email-insurance_contact').value
        if ( contact_company_email=== "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Insurance Contact Email'  + '<br>'
            form_completed = false
        } else {
            if (!validateEmail(contact_company_email)) {
                error_title_body.innerHTML += 'Insurance Contact Email is invalid' + '<br>'
                form_completed = false
            }
        }
        let phone_no=document.getElementById('phone-insurance_contact').value;
        if (phone_no === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Insurance Phone Number'+ '<br>'
            form_completed = false
        }
     
    

        else{
            if(!validatePhone(phone_no))
            {
                error_title_body.innerHTML += 'Insurance Contact Number is invalid' + '<br>'
                form_completed = false
            }
        }

        if (!document.getElementById('certificate-0').value ||
        document.getElementById('certificate-0').value === "") {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'No certificate uploaded' +'<br>'
        form_completed = false
    }
    if(document.getElementById('add-policy-table').children.length == 0)
    {
    error_title_body.innerHTML += 'Policy is Required'+'<br>'
    form_completed = false;

    }
    
    
    
    if (form_completed) {
      
        submitTanentCreationForm();
    } else {
        $("#error-modal").modal('show')
    }
}
function validatePhone (phone){
    const re= /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
    return re.test(phone);
}
function validateEmail (email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function confirmSubscriptionUpdate (created_contractors) {
    let total_contractors = created_contractors + parseInt(document.getElementById('certificates').value)
    let subscription_certs = parseInt(document.getElementById('subscription-certs').value)
    if (total_contractors > subscription_certs) {
        $("#subscription-update-confirm").modal('show')
    } else {
        submitPartnerCreationForm()
    }
}

function submitPartnerCreationForm () {
    document.getElementById("add-partner-form").submit();
}
function submitTanentCreationForm () {
    document.getElementById("add-tenant-form").submit();
}

function validatePartnerEditForm () {
    let error_title = 'Missing required field'

    if (document.getElementById('name-company').value === "") {
        $("#error-modal").modal('show')
        document.getElementById('error-title').innerHTML = error_title
        document.getElementById('error-body').innerHTML = 'Company name is missing'
        return false
    }
    if (document.getElementById('name-contact').value === "") {
        $("#error-modal").modal('show')
        document.getElementById('error-title').innerHTML = error_title
        document.getElementById('error-body').innerHTML = 'Contact name is missing'
        return false
    }
    if (document.getElementById('email-contact').value === "") {
        $("#error-modal").modal('show')
        document.getElementById('error-title').innerHTML = error_title
        document.getElementById('error-body').innerHTML = 'Contact email is missing'
        return false
    }
    if (document.getElementById('certificate-0').value === "" || !document.getElementById('certificate-0').value) {
        $("#error-modal").modal('show')
        document.getElementById('error-title').innerHTML = error_title
        document.getElementById('error-body').innerHTML = 'No certificate uploaded'
        return false
    }
    if (document.getElementById('name-producer_company').value === "") {
        $("#error-modal").modal('show')
        error_title_element.innerHTML = error_title
        document.getElementById('error-body').innerHTML = 'Insurance Company Name is missing'
        return false
    }
    if (document.getElementById('name-producer').value === "") {
        $("#error-modal").modal('show')
        error_title_element.innerHTML = error_title
        
        document.getElementById('error-body').innerHTML = 'Insurance Contact Name is missing'
        return false
    }
    let contact_company_email = document.getElementById('email-insurance_contact').value
    if ( contact_company_email=== "") {
        $("#error-modal").modal('show')
        error_title_element.innerHTML = error_title
      
        document.getElementById('error-body').innerHTML = 'Insurance Contact Email is missing'
        return false
    } 
    let phone_no=document.getElementById('phone-insurance_contact').value;
    if (phone_no === "") {
        $("#error-modal").modal('show')
        error_title_element.innerHTML = error_title
       
        document.getElementById('error-body').innerHTML = 'Insurance Phone Number is missing'
        return false
    }
    
    document.getElementById('edit-partner-form').submit()
}

$(document).ready(function () {
    certificateDragDrop('0')
})

function certificateDragDrop (id) {
    let certificateElement = $('#draggable')
    draggableElement(certificateElement)
    certificateElement.on('dragstart dragend  dragenter',function(e) {
        e.preventDefault();
        document.getElementById("cert-upload-div-"+id).classList.add('dragging');
    });
    certificateElement.on('dragover', function(e) {
        e.preventDefault();
        document.getElementById("cert-upload-div-"+id).classList.add('dragging');
    });
    
    certificateElement.on('dragleave',function(e) {
        e.preventDefault();
        document.getElementById("cert-upload-div-"+id).classList.remove('dragging');
    });
    certificateElement.on('drop', function (e) {
        e.preventDefault();
        document.getElementById("cert-upload-div-"+id).classList.remove('dragging');
        let files = e.originalEvent.dataTransfer.files;
        if (files.length > 1) {
            $("#error-modal").modal('show')
            document.getElementById('error-title').innerHTML = 'File limit exceeded'
            document.getElementById('error-body').innerHTML = 'You can only upload one file'
            return false
        }
        uploadCertificate(files[0], id)
    });
}
function validateCertfile (file, file_name, event) {
    console.log("validateCertfile file: ", file);
    var sizeInBytes = file.size;
    var size = sizeInBytes / (1024 * 1024);
    console.log("sizeInBytes: " + sizeInBytes);
    console.log("size: " + size);
    let splitted_name = file_name.split('.')
    let extension = splitted_name[splitted_name.length - 1].toLowerCase()
    if (size > 2) {
        document.getElementById('file_type').style.display = "none";
        document.getElementById('cert_error').style.display="none";
        document.getElementById('file_size').style.display = "block"
        if (event)
            event.target.value = ""
        return false
    } else if (extension !== 'pdf') {
            document.getElementById('file_size').style.display = "none"
            document.getElementById('cert_error').style.display="none";
            document.getElementById('file_type').style.display = "block";
            
        if (event)
            event.target.value = ""
        return false
    }
    return true;
}
function uploadCertificate (file, id, event) {
    console.log('uploadCertificate file: ', file);
      if (validateCertfile(file, file['name'], event)) {
        document.getElementById("cert-file-name-"+id).classList.add("loader"); 
        document.getElementById("cert-file-name-"+id).classList.add("mx-auto"); 
        let formData = new FormData();
        const urlParams = new URLSearchParams(window.location.search);
        const contractorId = urlParams.get('id'); // Extract 'id' from URL, e.g., ?id=4
        console.log("contractor_id: " + contractorId);
        formData.append("cert", file);
        formData.append("_token", $('meta[name="csrf-token"]').attr('content'));
        formData.append("contractor_id", contractorId); // Append the contractor_id to the formData

        axios.post('/upload/cert', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(function (resp) {
            if (window.location.href.indexOf("update/existing/contractor") > -1)
            {
            document.getElementById('confirm_certificate').disabled = false;
            document.getElementById('confirm_certificate').style.cursor = "pointer";
            }
            if(document.getElementById('cert-file-name-' + id).children.length!=0)
            {
                document.getElementById('file-name-div').remove;
            }
           var html=  '<div class="file-name-div d-flex" id="file-name-div">' 
           html += '<div class="text-width" style="width:120px !important" data-toggle="tooltip" data-placement="top" title="'+resp.data.file_name+'" target="_blank"> '
            html += '<a id="cert_name-'+id+'"  href="'+ resp.data.url +'" target="_blank">  <span class="text-width text-color">' +resp.data.file_name+ ' </span> </a> </div>'
           html +='<a style="text-decoration: none !important;" href="'+ resp.data.url +'" target="_blank"><svg class="search-icon" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M10.7204 9.32909H10.0429L9.80274 9.1001C10.6432 8.13327 11.1492 6.87808 11.1492 5.51264C11.1492 2.46797 8.65352 0 5.57461 0C2.49571 0 0 2.46797 0 5.51264C0 8.55732 2.49571 11.0253 5.57461 11.0253C6.9554 11.0253 8.2247 10.5249 9.2024 9.69377L9.43396 9.93124V10.6012L13.7221 14.8333L15 13.5696L10.7204 9.32909ZM5.57461 9.32909C3.43911 9.32909 1.71527 7.62441 1.71527 5.51264C1.71527 3.40088 3.43911 1.6962 5.57461 1.6962C7.71012 1.6962 9.43396 3.40088 9.43396 5.51264C9.43396 7.62441 7.71012 9.32909 5.57461 9.32909Z" fill="#6673E0"/></svg> </a>'
            html +='<a onclick="deleteCert('+id+')"><svg class="delete-icon"  width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M0.857143 13.6381C0.857143 14.5758 1.62857 15.3429 2.57143 15.3429H9.42857C10.3714 15.3429 11.1429 14.5758 11.1429 13.6381V3.40953H0.857143V13.6381ZM2.57143 5.1143H9.42857V13.6381H2.57143V5.1143ZM9 0.852383L8.14286 0H3.85714L3 0.852383H0V2.55715H12V0.852383H9Z" fill="#6673E0" /> </svg> </a>'
            html +='</div>'
            document.getElementById("cert-file-name-"+id).classList.remove("loader"); 
            document.getElementById("cert-file-name-"+id).classList.remove("mx-auto"); 
             document.getElementById('cert-file-name-' + id).innerHTML = html;
            document.getElementById('certificate-' + id).value = resp.data.path
            if(window.location.href.indexOf("update/existing/contractor") > -1)
            {
                document.getElementById('cert_error').classList.add('d-none');
                document.getElementById('file_size').classList.add('d-none');
                document.getElementById('file_type').classList.add('d-none');

            }
            else{
            document.getElementById('add-policy').classList.remove('d-none');
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 413) {
                // Show an alert or open a dialog box
                alert('The file is too large. Please select a smaller file.');
            } else {
                // Handle other types of errors
                console.error('Error uploading file:', error);
                alert('An error occurred while uploading the file.');
            }
            document.getElementById("cert-file-name-"+id).classList.remove("loader"); 
            document.getElementById("cert-file-name-"+id).classList.remove("mx-auto"); 
        });
    }
}

function deleteCert (id){
   let cert= document.getElementById('cert-file-name-' + id);
   cert.innerHTML="";
   document.getElementById("certificate-upload-"+id).value=null;
   
}
function confirmCert (id){
    
            document.getElementById('file_type').style.display = "none";
            document.getElementById('file_size').style.display = "none"

        if(document.getElementById('cert-file-name-' + id).children.length == 0)
        {
            document.getElementById('cert_error').style.display="block";
        }
        else{
            let contractor_id=document.getElementById('partner_id').value;
            let certificate_id=document.getElementById('certificate_id').value;
            let certificate=document.getElementById('certificate-'+id).value;
            axios.post('/update/certificate', {
                contractor_id,
                certificate_id,
                certificate,
            }).then(function (resp) {
                var today = new Date().toISOString().slice(0, 10);
                document.getElementById('cert_error').style.display="none";
                document.getElementById('update_coi').classList.add("d-none");
                if(document.getElementById('add-policy').classList.contains('d-none')){
                    document.getElementById('add-policy').classList.remove('d-none')
                 }
                var html='<div class="col-3"> <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="5" cy="5" r="5" fill="#48AA71" /> </svg> Active </div>'
                html+= '<div class="col-3" id="date"> '+ today +' </div>'
                html+=' <div class="col-3"><a href="' + resp.data.download_link + '"  target="_blank" class="file-name d-flex align-items-center text-width" data-toggle="tooltip" data-placement="top" title="'+resp.data.certificate_title+'" > <svg class="mr-2" width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg" > '
                html+=' <path d="M7.5 1.44444C10.0841 1.44444 12.3886 2.98278 13.5136 5.41667C12.3886 7.85056 10.0841 9.38889 7.5 9.38889C4.91591 9.38889 2.61136 7.85056 1.48636 5.41667C2.61136 2.98278 4.91591 1.44444 7.5 1.44444ZM7.5 0C4.09091 0 1.17955 2.24611 0 5.41667C1.17955 8.58722 4.09091 10.8333 7.5 10.8333C10.9091 10.8333 13.8205 8.58722 15 5.41667C13.8205 2.24611 10.9091 0 7.5 0ZM7.5 3.61111C8.44091 3.61111 9.20455 4.42 9.20455 5.41667C9.20455 6.41333 8.44091 7.22222 7.5 7.22222C6.55909 7.22222 5.79545 6.41333 5.79545 5.41667C5.79545 4.42 6.55909 3.61111 7.5 3.61111ZM7.5 2.16667C5.80909 2.16667 4.43182 3.62556 4.43182 5.41667C4.43182 7.20778 5.80909 8.66667 7.5 8.66667C9.19091 8.66667 10.5682 7.20778 10.5682 5.41667C10.5682 3.62556 9.19091 2.16667 7.5 2.16667Z" fill="#6673E0" /> </svg>'
                html+=  ' '+resp.data.certificate_title+' </a> </div>'
                document.getElementById("cert_data-"+id).innerHTML=html;
                document.getElementById('policies_table').innerHTML="";
                
                var table_html="";
              
              for(var i=0; i<resp.data.policies.length;i++ )
              {
              
                table_html +='<tr class="table-row" id="policy-'+ i +'">'
                table_html += '<td class="table-data">'
               
                var date = new Date(resp.data.policies[i].effective_date);
                var today= new Date();
                table_html += '<svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" > <circle cx="5" cy="5" r="5" fill="#DBE0E4" /> </svg> Not In Effect'
                var effective_date = changeDateFormat(resp.data.policies[i].effective_date);
                table_html += '</td>'
                table_html +=  '<td class="table-data">'+resp.data.policies[i].policies_type.name + '</td>'
                table_html += '<input type="hidden" id="policy_id-'+i+'" value="'+resp.data.policies[i].id+' " />'

                table_html +='<td class="table-data"> <input type="text" class="resize" required id="datepicker-'+i+'"  onkeyup="window.contractorsModule.addingslash(\'datepicker-'+i+'\')" name="policies['+i+'][effective_date]" placeholder="MM/DD/YYYY" onfocus="window.contractorsModule.emptyDatePicker(\'datepicker-'+i+'\')" onchange="window.contractorsModule.expired_value(\'datepicker-'+i+'\','+i+')"  /></td>'

               table_html+= '<td class="table-data" id="expiry_date-'+i+'"></td> <td class="table-data"></td> <td class="table-data"></td><td class="table-data"> </td>'
               table_html += '<td>'
               table_html += ' <a onclick="delete_policy_modal('+resp.data.policies[i].id+','+i+')">  <svg class="del-btn" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" >'
               table_html +=  '<path d="M9.42857 5.14286V13.7143H2.57143V5.14286H9.42857ZM8.14286 0H3.85714L3 0.857143H0V2.57143H12V0.857143H9L8.14286 0ZM11.1429 3.42857H0.857143V13.7143C0.857143 14.6571 1.62857 15.4286 2.57143 15.4286H9.42857C10.3714 15.4286 11.1429 14.6571 11.1429 13.7143V3.42857Z" fill="#FF7979" /> </svg> </a>'
                table_html+='</tr>'
                
              
            }
          
            document.getElementById('save-cert-button').classList.remove('d-none');
            document.getElementById('button-div').classList.remove('d-none');

            document.getElementById('policies_table').innerHTML=table_html;
            for(var i=0; i<resp.data.policies.length;i++)
            {
            var effective_date = changeDateFormat(resp.data.policies[i].effective_date);
            emptyDatePicker('datepicker-'+i);
            }
            document.getElementById('new_certificate_id').value=resp.data.id;
                
                $('#confirm_cert_modal').modal('show');
                 let cert= document.getElementById('cert-file-name-' + id);
                 cert.innerHTML="";
                 document.getElementById("certificate-upload-"+id).value=null;
                $('#exampleModalCenter-'+id).modal('hide');
            });
           
            
        }
}
function expired_value (datepicker_id,id)
{
    const oneDay = 24 * 60 * 60 * 1000;
    var effective_date=document.getElementById(datepicker_id).value;
  
    if(effective_date)
    {
    console.log(effective_date);
    var varDate = new Date(effective_date);
    var today = new Date();
    varDate.setFullYear( varDate.getFullYear() + 1 );
    varDate.setHours(0,0,0,0);
    const diffDays = Math.round(Math.abs((varDate - today) / oneDay));
    document.getElementById('expiry_date-'+id).innerHTML='in '+diffDays+' days';  
    
    }
}
function delete_policy_modal (policy_id,row_id)
{
    $('#delete-policy').modal('show');
    document.getElementById('policy_id').value=policy_id;
    document.getElementById('row_id').value=row_id;
}
function delete_policy (){
    let policy_id=  document.getElementById('policy_id').value;
    let row_id= document.getElementById('row_id').value;
    if(policy_id != "")
    {
    axios.delete('/delete/policy', {
        params: {
            id: policy_id
        }
    }).then(function (resp) {
        document.getElementById('policy-'+row_id).remove();
        
       
    });
}
else{
    document.getElementById('policy-'+row_id).remove();
 
}
$('#delete-policy').modal('hide');

}
function delete_policy_add ()
{
    let row_id= document.getElementById('row_id').value;
    document.getElementById('policy-'+row_id).remove();
    if(document.getElementById('policies_table').children.length==0)
    {
        document.getElementById('policy-table-header').remove();
        document.getElementById('policies_table').remove();
    }
    $('#add-delete-policy').modal('hide');
}

function editContractorAuditWizard (contractor_id, property_id) {
    axios.put('/update/session', {
        selectedPropertyId: {property_id}
    }).then(function (resp) {
        if (resp.data.status) {
            window.location.href = '/update/existing/contractor?id=' + contractor_id
        }
    })
}
function policies (contractor) {
    axios.get('getpolicies', {
        params: {
            id:contractor,
        }
        }).then(function (resp) {
        var html=""
        for(var i=0 ;i<resp.data.length;i++)
        {
             html += "<tr id='"+i+"'>"
            html+="<td>"+ i+1 +" </td>"
            html+=" <td>"+ resp.data[i].policies_type.name    +"</td>"
            html+="<td>"+ resp.data[i].effective_date +"</td>"
            html+="<td>"+resp.data[i].expiration_date +"</td>" 
            html+="</tr>";
            document.getElementById("policies_data").innerHTML = html;
        }   
    })
}
function activehover (id) {
    var active= document.getElementById("active-status-link-"+id);
    active.classList.add("d-none");
    var inactive=document.getElementById("archived-status-"+id)
    inactive.classList.remove("d-none");
};

function activeUnhover (id) {
    var inactive=document.getElementById("archived-status-"+id)
    inactive.classList.add("d-none");
    var active= document.getElementById("active-status-link-"+id);
    active.classList.remove("d-none");
    
}
function inactivehover (id) {
    var active= document.getElementById("archived-status-link-"+id);
    active.classList.add("d-none");
    var inactive=document.getElementById("active-status-"+id)
    inactive.classList.remove("d-none");
};

function inactiveUnhover (id)
{
    var inactive=document.getElementById("active-status-"+id)
    inactive.classList.add("d-none");
    var active= document.getElementById("archived-status-link-"+id);
    active.classList.remove("d-none");
}
function edit_contractor_info (contractor_id) {
    document.getElementById("contractor_info-"+contractor_id).classList.add('d-none');
    document.getElementById("edit_contractor_info-"+contractor_id).classList.remove('d-none');
    document.getElementById("edit-button").classList.add('d-none');
    document.getElementById("save-button").classList.remove('d-none');
    document.getElementById("save-button").classList.add('d-flex');
}
function savePartnerInfo (is_pm,type) {
    let error_title = 'Missing required field'
    let error_title_element = document.getElementById('error-title')
    let error_title_body = document.getElementById('error-body');
    error_title_body.innerHTML = ""
    let form_completed = true
    if(type=="T")
    {
        let company_name=document.getElementById('tanent-company').value;

        if (company_name === "") {
                error_title_element.innerHTML = error_title
                error_title_body.innerHTML += 'Tenant name is missing' +  '<br>'
                form_completed = false
            }
            else{ if(!validateName(company_name)) {
                error_title_element.innerHTML = error_title
                error_title_body.innerHTML += 'Tenant Name is Invalid'+ '<br>'
                form_completed = false
            }
            }

            let contact_email = document.getElementById('email-tenant').value
            if (contact_email === "") {
                error_title_element.innerHTML = error_title
                error_title_body.innerHTML += 'Tenant email is missing'+ '<br>'
                form_completed = false
            } else {
                if (!validateEmail(contact_email)) {
                    error_title_body.innerHTML += 'Tenant email is invalid' + '<br>'
                    form_completed = false
                }
            }
            let tenant_phone = document.getElementById('tenant-contact').value
            if(tenant_phone ==="")
            {
                error_title_element.innerHTML = error_title
                error_title_body.innerHTML += 'Tenant phone no is missing'+ '<br>'
                form_completed = false
            }
            let address_tenant=document.getElementById('address_tenant')
            if(address_tenant ==="")
            {
                error_title_element.innerHTML = error_title
                error_title_body.innerHTML += 'Tenant address is missing'+ '<br>'
                form_completed = false
            }
            if (form_completed) {
                let id=document.getElementById('partner_id').value;
                let contractor_company_name=document.getElementById('tanent-company').value;
                let contractor_contact_name=document.getElementById('tanent-company').value;
                let contractor_contact_email=document.getElementById('email-tenant').value;
                let tenant_phone=document.getElementById('tenant-contact').value;
                let tenant_address=document.getElementById('address_tenant').value;

                axios.post('/update/partner-info', {
                    id,
                    contractor_company_name,
                    contractor_contact_name,
                    contractor_contact_email,
                    tenant_phone,
                    tenant_address,
                    type
                }).then(function (resp) {
                    document.getElementById("contractor_info-0").classList.remove('d-none');
                    document.getElementById("edit_contractor_info-0").classList.add('d-none');
                    document.getElementById("edit-button").classList.remove('d-none');
                    document.getElementById("save-button").classList.add('d-none');
                    document.getElementById("save-button").classList.remove('d-flex');
                    document.getElementById('tenant_name').value=resp.data.contractor_company_name;
                    document.getElementById('tenant_phone').value=resp.data.tenant_phone;
                    document.getElementById('tenant_email').value=resp.data.contractor_contact_email;
                    document.getElementById('tenant_address').value=resp.data.tenant_address;

                    document.getElementById('tenant-company').value=resp.data.contractor_company_name;
                    document.getElementById('tenant-contact').value=resp.data.tenant_phone;
                    document.getElementById('email-tenant').value=resp.data.contractor_contact_email;
                    document.getElementById('address_tenant').value=resp.data.tenant_address;
                });
                } else {
                    $("#error-modal").modal('show')
                }
    }
    else{
    let company_name=document.getElementById('name-company').value;
    let contact_name=document.getElementById('name-contact').value;
    if (company_name === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Company name is missing' +  '<br>'
            form_completed = false
        }
        else{ if(!validateName(company_name)) {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Company Name is Invalid'+ '<br>'
            form_completed = false
        }
        }
        if (contact_name === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Contact name is missing' + '<br>'
            form_completed = false
        }
        else{
            if(!validateName(contact_name)){
                error_title_element.innerHTML = error_title
                error_title_body.innerHTML += 'Contact Name is Invalid'+ '<br>'
                form_completed = false
            }
        }
        let contact_email = document.getElementById('email-contact').value
        if (contact_email === "") {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Contact email is missing'+ '<br>'
            form_completed = false
        } else {
            if (!validateEmail(contact_email)) {
                error_title_body.innerHTML += 'Contact email is invalid' + '<br>'
                form_completed = false
            }
        }
        if (form_completed) {
        let id=document.getElementById('partner_id').value;
        let contractor_company_name=document.getElementById('name-company').value;
        let contractor_contact_name=document.getElementById('name-contact').value;
        let contractor_contact_email=document.getElementById('email-contact').value;
        
        axios.post('/update/partner-info', {
            id,
            contractor_company_name,
            contractor_contact_name,
            contractor_contact_email,
            type
            
            
        }).then(function (resp) {
            document.getElementById("contractor_info-0").classList.remove('d-none');
            document.getElementById("edit_contractor_info-0").classList.add('d-none');
            document.getElementById("edit-button").classList.remove('d-none');
            document.getElementById("save-button").classList.add('d-none');
            document.getElementById("save-button").classList.remove('d-flex');
            document.getElementById('comapny_name').value=resp.data.contractor_company_name;
            document.getElementById('contact_name').value=resp.data.contractor_contact_name;
            document.getElementById('contact_email').value=resp.data.contractor_contact_email;
            document.getElementById('name-company').value=resp.data.contractor_company_name;
            document.getElementById('name-contact').value=resp.data.contractor_contact_name;
            document.getElementById('email-contact').value=resp.data.contractor_contact_email;
        });
        } else {
            $("#error-modal").modal('show')
        }
    }
}
function cancelPartnerInfo (is_pm,type) {
    if(type == "T") {
        document.getElementById('tanent-company').value=document.getElementById('tenant_name').value;
        document.getElementById('tenant-contact').value=document.getElementById('tenant_phone').value;
        document.getElementById('email-tenant').value=document.getElementById('tenant_email').value;
        document.getElementById('address_tenant').value=document.getElementById('tenant_address').value;
        document.getElementById("contractor_info-0").classList.remove('d-none');
        document.getElementById("edit_contractor_info-0").classList.add('d-none');
        document.getElementById("edit-button").classList.remove('d-none');
        document.getElementById("save-button").classList.add('d-none');
        document.getElementById("save-button").classList.remove('d-flex');
    } else {
        document.getElementById('name-company').value= document.getElementById('comapny_name').value;
        document.getElementById('name-contact').value= document.getElementById('contact_name').value;
        document.getElementById('email-contact').value=document.getElementById('contact_email').value;
        document.getElementById("contractor_info-0").classList.remove('d-none');
        document.getElementById("edit_contractor_info-0").classList.add('d-none');
        document.getElementById("edit-button").classList.remove('d-none');
        document.getElementById("save-button").classList.add('d-none');
        document.getElementById("save-button").classList.remove('d-flex');
    }
}
function validateName (name) {
    const re = /^[A-z0-9,. "\'&~_-]+$/;
    return re.test(name);
}
function edit_insurance_info (contractor_id) {
    document.getElementById("producer_info-"+contractor_id).classList.add('d-none');
    document.getElementById("edit_producer_info-"+contractor_id).classList.remove('d-none');
    document.getElementById("edit-producer-button").classList.add('d-none');
    document.getElementById("save-producer-button").classList.remove('d-none');
    document.getElementById("save-producer-button").classList.add('d-flex');
}
function saveProducerInfo () {
    let error_title = 'Missing required field'
    let error_title_element = document.getElementById('error-title')
    let error_title_body = document.getElementById('error-body');
    error_title_body.innerHTML = ""
    let form_completed = true
    let company_name=document.getElementById('name-producer_company').value;
    let contact_name=document.getElementById('name-producer').value;
    if (company_name === "") {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Company name is missing' +  '<br>'
        form_completed = false
    } else {
        if(!validateName(company_name)) {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Company Name is Invalid'+ '<br>'
            form_completed = false
        }
    }
    if (contact_name === "") {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Contact name is missing' + '<br>'
        form_completed = false
    } else {
        if(!validateName(contact_name)) {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Contact Name is Invalid'+ '<br>'
            form_completed = false
        }
    }
    let contact_email = document.getElementById('email-insurance_contact').value
    if (contact_email === "") {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Contact email is missing'+ '<br>'
        form_completed = false
    } else {
        if (!validateEmail(contact_email)) {
            error_title_body.innerHTML += 'Contact email is invalid' + '<br>'
            form_completed = false
        }
    }
    let phone_no=document.getElementById("phone-insurance_contact").value;
    if (phone_no === "") {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Phone Number is missing' +  '<br>'
        form_completed = false
    } else {
        if(!validatePhone(phone_no))
        {
            error_title_body.innerHTML += 'Insurance Contact Number is invalid'+ '<br>'
            form_completed = false
        }
    }
    if (form_completed) {
        let id=document.getElementById('partner_id').value;
        let producer_company_name=document.getElementById('name-producer_company').value;
        let producer_contact_name=document.getElementById('name-producer').value;
        let producer_contact_email=document.getElementById('email-insurance_contact').value;
        let producer_contact_phone=document.getElementById('phone-insurance_contact').value;
        axios.post('/update/partner-info', {
            id,
            producer_company_name,
            producer_contact_name,
            producer_contact_email,
            producer_contact_phone,
        }).then(function (resp) {
            document.getElementById("producer_info-0").classList.remove('d-none');
            document.getElementById("edit_producer_info-0").classList.add('d-none');
            document.getElementById("edit-producer-button").classList.remove('d-none');
            document.getElementById("save-producer-button").classList.add('d-none');
            document.getElementById("save-producer-button").classList.remove('d-flex');
            document.getElementById('producer_company').value=resp.data.producer_company_name;
            document.getElementById('producer_manager').value=resp.data.producer_contact_name;
            document.getElementById('producer_email').value=resp.data.producer_contact_email;
            document.getElementById('producer_phone').value=resp.data.producer_contact_phone;
            document.getElementById('name-producer_company').value=resp.data.producer_company_name;
            document.getElementById('name-producer').value=resp.data.producer_contact_name;
            document.getElementById('email-insurance_contact').value=resp.data.producer_contact_email;
            document.getElementById('phone-insurance_contact').value=resp.data.producer_contact_phone;
            });
    } else {
        $("#error-modal").modal('show')
    }
}
function cancelProducerInfo () {
    document.getElementById('name-producer_company').value=document.getElementById('producer_company').value;
    document.getElementById('name-producer').value= document.getElementById('producer_manager').value;
    document.getElementById('email-insurance_contact').value= document.getElementById('producer_email').value  ;
    document.getElementById('phone-insurance_contact').value=document.getElementById('producer_phone').value;
    document.getElementById("producer_info-0").classList.remove('d-none');
    document.getElementById("edit_producer_info-0").classList.add('d-none');
    document.getElementById("edit-producer-button").classList.remove('d-none');
    document.getElementById("save-producer-button").classList.add('d-none');
    document.getElementById("save-producer-button").classList.remove('d-flex');

}

function confirmCert1 (id){
    let today = new Date().toISOString().slice(0, 10)
            document.getElementById('file_type').style.display = "none";
            document.getElementById('file_size').style.display = "none"

        if(document.getElementById('cert-file-name-' + id).children.length == 0)
        {
            document.getElementById('cert_error').style.display="block";
        }
        else{
            let path= document.getElementById('certificate-' + id).value;
            
            let cert_name=document.getElementById('cert_name-'+id).innerHTML;
            document.getElementById('cert_error').style.display="none";
            var html='<div class="col-3"> <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="5" cy="5" r="5" fill="#48AA71" /> </svg> Active </div>'
            html+= '<div class="col-3" id="date"> '+today +' </div>'
            html+=' <div class="col-3"><a href="/storage/'+path+'" target="_blank" class="file-name d-flex align-items-center"> <svg class="mr-2" width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg" > '
            html+=' <path d="M7.5 1.44444C10.0841 1.44444 12.3886 2.98278 13.5136 5.41667C12.3886 7.85056 10.0841 9.38889 7.5 9.38889C4.91591 9.38889 2.61136 7.85056 1.48636 5.41667C2.61136 2.98278 4.91591 1.44444 7.5 1.44444ZM7.5 0C4.09091 0 1.17955 2.24611 0 5.41667C1.17955 8.58722 4.09091 10.8333 7.5 10.8333C10.9091 10.8333 13.8205 8.58722 15 5.41667C13.8205 2.24611 10.9091 0 7.5 0ZM7.5 3.61111C8.44091 3.61111 9.20455 4.42 9.20455 5.41667C9.20455 6.41333 8.44091 7.22222 7.5 7.22222C6.55909 7.22222 5.79545 6.41333 5.79545 5.41667C5.79545 4.42 6.55909 3.61111 7.5 3.61111ZM7.5 2.16667C5.80909 2.16667 4.43182 3.62556 4.43182 5.41667C4.43182 7.20778 5.80909 8.66667 7.5 8.66667C9.19091 8.66667 10.5682 7.20778 10.5682 5.41667C10.5682 3.62556 9.19091 2.16667 7.5 2.16667Z" fill="#6673E0" /> </svg>'
            html+=  ' '+cert_name+' </a> </div>'
            document.getElementById("cert_data-"+id).innerHTML=html;
            $('#exampleModalCenter-'+id).modal('hide');
        }
        
}
function save_policy (row_id){
    let certificate_id=document.getElementById('new_certificate_id').value;
    let policy_type=document.getElementById('type'+row_id).value;
    let effective_date=document.getElementById('contractor-0-datepicker-'+row_id).value;
    let error_title = 'Missing required field'
let error_title_element = document.getElementById('error-title')
let error_title_body = document.getElementById('error-body');
error_title_body.innerHTML = ""
let form_completed = true

    if(certificate_id=="")
    {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'New Certificate File is Missing'+ '<br>'
        form_completed = false
    }
    if(policy_type.trim() == "")
    {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Policy Type is Required'+ '<br>'
        form_completed = false
    }
    if(effective_date =="")
    {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Effective Date is Required'+ '<br>'
        form_completed = false
    }
    else{
        var varDate = new Date(effective_date);
        var today = new Date();
        today.setFullYear( today.getFullYear() - 1 );
        today.setHours(0,0,0,0);
        if(moment(effective_date, 'MM/DD/YYYY',true).isValid()==false){
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Effective Date is Invalid'+ '<br>'
        form_completed = false
        }
        else if(varDate < today)
            {
                error_title_element.innerHTML = error_title
                error_title_body.innerHTML += 'Effective Date cannot be older than a year'+ '<br>'
                form_completed = false
            }
        }
    
    if (form_completed) {
        axios.post('/save/policy', {
            policy:policy_type,
            effective_date:effective_date,
            certificate_id:certificate_id

        }).then(function (resp)
        {
                document.getElementById('add-policy').disabled=false;
            document.getElementById("add-policy").style.cursor="pointer";
                var rowCount = $('#policies_table >tr').length;
                var html='<tr class="table-row" id="policy-'+rowCount+'">';
                if(resp.data.diffInHours <= 0)
                {
                    html += '<td class="table-data">  <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none"  xmlns="http://www.w3.org/2000/svg"> <circle cx="5" cy="5" r="5" fill="#FF7979" /> </svg> Expired </td>'
                }
                else{
                    var date = new Date(resp.data.effective_date);
                    var today= new Date();
                if(date > today)
                    {

                    html += '<td class="table-data">   <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" > <circle cx="5" cy="5" r="5" fill="#DBE0E4" /></svg>  Not In Effect </td>'

                    }
                    else{
                        html += '<td class="table-data">   <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" > <circle cx="5" cy="5" r="5" fill="#48AA71" /></svg> Effective </td>'
                    }
                }
                html += ' <td class="table-data">'+ policy_type +'</td >';
                var effective_date= moment(date).format("MMM Do YYYY");
                html += '<td class="table-data">'+ effective_date +'</td>'
                if(resp.data.diffInHours > 0)
                {
                html += '<td class="table-data"> in '+ resp.data.expires_in +" "+ resp.data.expiry_duration+'s </td>'
                }
                else{
                html += '<td class="table-data"> Expired '+ resp.data.expires_in +" "+ resp.data.expiry_duration+'s ago </td>'    
                }
                html += ' <td class="table-data"></td> <td class="table-data"></td> <td class="table-data"></td>'
                html += '<td><a onclick="delete_policy_modal('+resp.data.id+','+rowCount+')">  <svg class="del-btn" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" >'
                html +=  '<path d="M9.42857 5.14286V13.7143H2.57143V5.14286H9.42857ZM8.14286 0H3.85714L3 0.857143H0V2.57143H12V0.857143H9L8.14286 0ZM11.1429 3.42857H0.857143V13.7143C0.857143 14.6571 1.62857 15.4286 2.57143 15.4286H9.42857C10.3714 15.4286 11.1429 14.6571 11.1429 13.7143V3.42857Z" fill="#FF7979" /> </svg> </a>'
                html += '</td>'
                html += '</tr>'
                $('#policies_table').append(html);
                    document.getElementById("contractor-0-policy-"+row_id).remove();
            });

    } else {
        $("#error-modal").modal('show')
    }
}
function active_policy_modal (row_id)
{
    let policy_id=document.getElementById('new_policy-'+row_id).value;
    $("#delete-active-policy").modal('show')
    document.getElementById('policy_id').value=policy_id;
    document.getElementById('row_id').value=row_id;
}
function delete_active_policy (){
    let policy_id=  document.getElementById('policy_id').value;
    let row_id= document.getElementById('row_id').value;

    axios.delete('/delete/policy', {
        params: {
            id: policy_id
        }
    }).then(function (resp) {
        document.getElementById('contractor-0-policy-'+row_id).remove();
        let prev_id=row_id-1;
        
        if(document.getElementById('contractor-0-policy-'+prev_id).children.length>0)
        {
            document.getElementById('contractor-0-policy-'+prev_id).style.padding="20px 40px 40px 40px";
            document.getElementById('contractor-0-content-'+prev_id).classList.remove('d-none')
            document.getElementById('contractor-0-content-'+prev_id).classList.add("d-flex");
        }
        $('#delete-active-policy').modal('hide');
    });
}
function delete_modal (certificate_id,certificate_date)
{
    document.getElementById('certificate_date').innerHTML=certificate_date;
    $("#delete-certificate").modal('show')
    document.getElementById('certificate_id').value=certificate_id;

}
function deleteCertificate ()
{
    let certificate_id=document.getElementById('certificate_id').value;
    let contractor_id=document.getElementById('contractor_id').value;
    let page_type=document.getElementById('page_type').value;
    axios.post('/delete/cert', {
        certificate_id,
        contractor_id,
    }).then(function (resp)
    {
        if(page_type=="audit_wizard")
        {
        window.location.href="/update/archive/contractor?id="+contractor_id+"&type="+page_type;
        } else {
            window.location.href="/update/archive/contractor?id="+contractor_id;
        }
    });
}
function closeModel () {
    $('#delete-certificate').modal('hide');
}
function show_eyeball (id)
{
    document.getElementById("eye-ball-"+id).classList.remove("d-none");
}
function hide_eyeball (id)
{
    document.getElementById("eye-ball-"+id).classList.add("d-none");
}
function addingslash (id)
{
var dateSoFar = document.getElementById(id);
var counter = dateSoFar.value.length;
if(counter == 2 || counter == 5 )
    document.getElementById(id).value = document.getElementById(id).value + '/';

}

function closeEditContractor () {
    let partner_edit=document.getElementById('save-button').classList.contains('d-none');
    let insurance_edit=document.getElementById('save-producer-button').classList.contains('d-none');
    if (partner_edit==false) {
        $('#close_edit').modal('show');
        document.getElementById('closing_url').value="/";

    } else if (insurance_edit==false) {
        $('#close_edit').modal('show');
        document.getElementById('closing_url').value="/";
    } else {
        window.location.href ="/";
    }
     
}
function close_edit () {
    url= document.getElementById('closing_url').value;
    window.location.href =url;
}
function dropdown_policies (id,types) {
    var available=[];
    console.log("types: ", types);
    for(var i=0;i<types.length;i++) {
        available.push(types[i].name);
    }
    $.widget("custom.autocompleteheader", $.ui.autocomplete, {
        _renderMenu: function (ul, items) {
            var self = this;
            $.each(items, function (index, item) {
                console.log("item: ", item);
                self._renderItemData(ul, item);
                if (index == 0) ul.prepend('<li class="header-auto"> Suggestions </li>');
            });
        }
    });
    $("#type"+id).autocompleteheader({
        source: available,
        minLength: 0,
        position: {
            my: "top+30",
        }
    }).focus(function () {
        $(this).autocompleteheader("search");
    });
}
function cancel_cert (id) {
    let cert= document.getElementById('cert-file-name-' + id);
    cert.innerHTML="";
    document.getElementById("certificate-upload-"+id).value=null;
    $('#exampleModalCenter-'+id).modal('hide');
}
function cancel_modal () {
    url= document.getElementById('closing_url').value;
    clicked_button= document.getElementById('clicked_button').value;
    if (clicked_button != "") {
        document.getElementById(clicked_button).href=url;
    }
    $("#close_edit").modal('hide')
}
function add_policy (row_id) {
    let policy_type=document.getElementById('type'+row_id).value;
    let effective_date=document.getElementById('contractor-0-datepicker-'+row_id).value;
    let error_title = 'Missing required field'
    let error_title_element = document.getElementById('error-title')
    let error_title_body = document.getElementById('error-body');
    error_title_body.innerHTML = ""
    let form_completed = true
  

    if(policy_type.trim() == "")
    {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Policy Type is Required'+ '<br>'
        form_completed = false
    }
    if(effective_date =="")
    {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Effective Date is Required'+ '<br>'
        form_completed = false
    }
    if (!document.getElementById('certificate-' + 0).value ||
    document.getElementById('certificate-' + 0).value === "") {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'No certificate uploaded' + '<br>'
        form_completed = false
    } else {
        var varDate = new Date(effective_date);
        var today = new Date();
        today.setFullYear( today.getFullYear() - 1 );
        today.setHours(0,0,0,0);
        if(moment(effective_date, 'MM/DD/YYYY',true).isValid()==false){
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Effective Date is Invalid'+ '<br>'
        form_completed = false
        }
      
    else if (varDate < today) {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Effective Date cannot be older than a year' + '<br>'
        form_completed = false
    }
}
    
    if (form_completed) {
            document.getElementById('add-policy').disabled=false;
            document.getElementById("add-policy").style.cursor="pointer";
        
            if(document.getElementById("add-policy-table").children.length == 0)
                {
              var table_html='<thead id="policy-table-header"> <tr>'
              table_html += '<th class="table-heading" scope="col">Policy Status</th>'
              table_html +=  '<th class="table-heading" scope="col">Policy Type</th>'
              table_html +=   '<th class="table-heading" scope="col">Effective Date</th>'
              table_html +=   '<th class="table-heading" scope="col">Expiration Date</th>'
              table_html +=    '<th class="table-heading" scope="col"></th>'
              table_html +=  '<th class="table-heading" scope="col"></th>'
              table_html +=   '<th class="table-heading" scope="col"></th>'
              table_html += '<th class="table-heading" scope="col"></th>'
              table_html += '</tr>'
              table_html += '</thead>'
              table_html +='<tbody id="policies_table">' 
              table_html +='</tbody>'
              $('#add-policy-table').append(table_html);
                }
                var date = new Date(effective_date);
                var newdate = new Date(date);
                newdate.setDate(date.getDate() + 365);
                newdate=moment(newdate);
                var today= new Date().toISOString().slice(0, 10);
                today=moment(today);
                var exp_date=newdate.diff(today, 'days');
                var today_date=new Date();
                var rowCount = $('#policies_table >tr').length;
                var html='<tr class="table-row" id="policy-'+rowCount+'">';
                if(today_date < date){
                html += '<td class="table-data">   <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" > <circle cx="5" cy="5" r="5" fill="#DBE0E4" /></svg> Not In Effect </td>'
                }
                else{
                html += '<td class="table-data">   <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" > <circle cx="5" cy="5" r="5" fill="#48AA71" /></svg> Effective </td>'
                }
                html += ' <td class="table-data"> <input type="text" class="fixed-input" style="background: transparent;" name="policies[contractor-0]['+rowCount+'][policy]" value="'+policy_type+'" readonly />  </td>';
                var effect_date= moment(date).format("MMM Do YYYY"); 
                html += '<td class="table-data"><input type="text" class="fixed-input" style="background: transparent;" name="policies[contractor-0]['+rowCount+'][effective_date]" value="'+effect_date+'" readonly /> </td>'
                
                 html += '<td class="table-data"> in '+  exp_date+ ' days </td>'    
               
                 html += ' <td class="table-data"></td> <td class="table-data"></td> <td class="table-data"></td>'

                html += '<td> <a onclick="open_delete_policy_modal('+rowCount+')">  <svg class="del-btn" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" >'
                html +=  '<path d="M9.42857 5.14286V13.7143H2.57143V5.14286H9.42857ZM8.14286 0H3.85714L3 0.857143H0V2.57143H12V0.857143H9L8.14286 0ZM11.1429 3.42857H0.857143V13.7143C0.857143 14.6571 1.62857 15.4286 2.57143 15.4286H9.42857C10.3714 15.4286 11.1429 14.6571 11.1429 13.7143V3.42857Z" fill="#FF7979" /> </svg> </a>'
                html += '</td>'
                html += '</tr>'
               
                html += '</tr>'
                $('#policies_table').append(html);
                 document.getElementById("contractor-0-policy-"+row_id).remove();
         

    } else {
        $("#error-modal").modal('show')
    }
  }
function open_delete_policy_modal (row_id) {
    $('#add-delete-policy').modal('show');
    document.getElementById('row_id').value=row_id;
}
$(document).ready(function () {
    addDatePicker('contractor-0-datepicker-0');
})
$("body").tooltip({
    selector: '[data-toggle="tooltip"]'
});
function sumbit_filter_form () {
    document.getElementById('loader').classList.remove('d-none');
    document.getElementById("filter_form").submit();
}
function delete_contractor (contractor_id) {
    $('#delete-partner').modal('show');
    document.getElementById('partner_id').value=contractor_id;
}
function delete_partner () {
    $("#delete-partner").modal('hide')
    let id = document.getElementById('partner_id').value
    axios.post('/delete/partner', {
       id        
    }).then(function (resp) {
      
        if (resp.data.success=true) {
            window.location.reload()
        } else {
            alert('Error occurred while deleting contractor')
        }
    }).catch(function () {
        alert('Error occurred while deleting contractor')
    })
}
function edit_policies (policy_id,policy_name,row_id,effective_date) {
    axios.get('/edit/policy/blade', {
        params: {
            id:row_id,
            policy_name:policy_name,
            effective_date:effective_date,
            policy_id: policy_id
        }   
    }).then(function (resp) {
        document.getElementById('policy-'+row_id).innerHTML=resp.data.html;
        dropdown_policies(row_id,resp.data.types);
        effective_date = document.getElementById('contractor-0-datepicker-' + row_id).value;
        addDatePicker('contractor-0-datepicker-'+row_id,effective_date);
    })
}
function save_edit_policy (policy_id,row_id) {
    let policy_type=document.getElementById('type'+row_id).value;
    let effective_date=document.getElementById('contractor-0-datepicker-'+row_id).value;
    let error_title = 'Missing required field'
    let error_title_element = document.getElementById('error-title')
    let error_title_body = document.getElementById('error-body');
    error_title_body.innerHTML = ""
    let form_completed = true
    if(policy_type.trim() == "") {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Policy Type is Required'+ '<br>'
        form_completed = false
    }
    if(effective_date =="") {
        error_title_element.innerHTML = error_title
        error_title_body.innerHTML += 'Effective Date is Required'+ '<br>'
        form_completed = false
    } else {
        var varDate = new Date(effective_date);
        var today = new Date();
        today.setFullYear( today.getFullYear() - 1 );
        today.setHours(0,0,0,0);
        if(moment(effective_date, 'MM/DD/YYYY',true).isValid()==false){
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Effective Date is Invalid'+ '<br>'
            form_completed = false
        } else if (varDate < today) {
            error_title_element.innerHTML = error_title
            error_title_body.innerHTML += 'Effective Date cannot be older than a year'+ '<br>'
            form_completed = false
        }
    }
    if(form_completed == true) {
        axios.post('/update/policy', {
            policy:policy_type,
            effective_date:effective_date,
            policy_id:policy_id,
        }).then(function (resp) {
            var html='';
            if(resp.data.diffInHours <= 0) {
                html += '<td class="table-data">  <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none"  xmlns="http://www.w3.org/2000/svg"> <circle cx="5" cy="5" r="5" fill="#FF7979" /> </svg> Expired </td>'
            } else {
                var date = new Date(resp.data.effective_date);
                var today= new Date();
                if(date > today) {
                    html += '<td class="table-data">   <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" > <circle cx="5" cy="5" r="5" fill="#DBE0E4" /></svg>  Not In Effect </td>'

                } else {
                    html += '<td class="table-data">   <svg class="mr-2" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" > <circle cx="5" cy="5" r="5" fill="#48AA71" /></svg> Effective </td>'
                }
            }
            html += ' <td class="table-data">'+ policy_type +'</td >';
            var effective_date= moment(date).format("MMM Do YYYY");
            html += '<td class="table-data">'+ effective_date +'</td>'
            if(resp.data.diffInHours > 0) {
                html += '<td class="table-data"> in '+ resp.data.expires_in +" "+ resp.data.expiry_duration+'s </td>'
            } else {
                html += '<td class="table-data"> Expired '+ resp.data.expires_in +" "+ resp.data.expiry_duration+'s ago </td>'    
            }
            html += ' <td class="table-data"></td> <td class="table-data"></td> <td class="table-data"></td>'
            html += '<td> <a  style="cursor:pointer"  class="edit-info" onclick="edit_policies('+resp.data.id+',\''+policy_type+'\','+row_id+',\''+effective_date+'\')" > <svg class="edit-icon" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" >'
            html += '<path d="M0 11.9446V15H3.0554L12.0668 5.98859L9.01141 2.93319L0 11.9446ZM15 3.0554L11.9446 0L9.88322 2.06953L12.9386 5.12493L15 3.0554Z" fill="#8A98AB" /> </svg></a>'
            html += '<a onclick="delete_policy_modal('+resp.data.id+','+row_id+')">  <svg class="del-btn" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" >'
            html +=  '<path d="M9.42857 5.14286V13.7143H2.57143V5.14286H9.42857ZM8.14286 0H3.85714L3 0.857143H0V2.57143H12V0.857143H9L8.14286 0ZM11.1429 3.42857H0.857143V13.7143C0.857143 14.6571 1.62857 15.4286 2.57143 15.4286H9.42857C10.3714 15.4286 11.1429 14.6571 11.1429 13.7143V3.42857Z" fill="#FF7979" /> </svg> </a>'
            html += '</td>'
            document.getElementById('policy-'+row_id).innerHTML=html;
        })
    } else {
        $("#error-modal").modal('show')
    }
}
function policies_form () {
    $('#confirm_policy_modal').modal('hide');
    var policies_length=document.getElementById('policies_table').children.length;
    let policies=[];
    let error_title = 'Missing required field'
    let error_title_element = document.getElementById('error-title')
    let error_title_body = document.getElementById('error-body');
    error_title_body.innerHTML = ""
    let form_completed = true
    for(i=0;i<=(policies_length-1);i++) {
        let policy_id=document.getElementById('policy_id-'+i);
        let effective_date=document.getElementById('datepicker-'+i);
        if(effective_date && policy_id) {
            policy_id=policy_id.value;
            effective_date=effective_date.value;
            console.log(effective_date);
           
            if(effective_date =="") {
                error_title_element.innerHTML = error_title
                error_title_body.innerHTML += 'Effective Date is Required'+ '<br>'
                form_completed = false
            } else {
                var varDate = new Date(effective_date);
                var today = new Date();
                today.setFullYear( today.getFullYear() - 1 );
                today.setHours(0,0,0,0);
                if(moment(effective_date, 'MM/DD/YYYY',true).isValid()==false){
                error_title_element.innerHTML = error_title
                error_title_body.innerHTML += 'Effective Date is Invalid'+ '<br>'
                form_completed = false
                } else if(varDate < today) {
                    error_title_element.innerHTML = error_title
                    error_title_body.innerHTML += 'Effective Date cannot be older than a year' + '<br>'
                    form_completed = false
                }
            }
            let j=i;
            j=[];
            j.push(policy_id);
            j.push(effective_date);
            policies.push(j);
        }
    }
    if(form_completed==true) {
        axios.post('/update/policy', {
            policies:policies,
        }).then(function (resp) {
            location.reload();
        });
    } else {
        $("#error-modal").modal('show')
    }
}

function changeDateFormat(inputDate) {  // expects Y-m-d
   
    var splitDate = inputDate.split('-');
    if(splitDate.count == 0){
        return null;
    }

    var year = splitDate[0];
    var month = splitDate[1];
    var day = splitDate[2]; 

    return month + '-' + day + '-' + year;
}

function toggleOrgList() {
    var orgList = document.getElementById("orgList");
    orgList.style.display = orgList.style.display === "none" ? "block" : "none";
}

document.addEventListener('DOMContentLoaded', function() {
    let updateCoiButton = document.getElementById('update_coi');
    if (updateCoiButton) {
        updateCoiButton.addEventListener('click', function() {
            const modalId = $(this).data('target');
            $(modalId).modal('show'); // Force show modal
            console.log('Modal shown:', modalId);
        });
    }
    let saveCertButton = document.getElementById('save-cert-button');
    if (saveCertButton) {
        saveCertButton.addEventListener('click', function() {
            const modalId = $(this).data('target');
            $(modalId).modal('show'); // Force show modal
            console.log('Modal shown:', modalId);
        });
    }
    $('.modal-button').on('click', function() {
        const modal = $(this).closest('.modal');
        modal.modal('hide');
        console.log('Modal hidden:', modal.attr('id'));
    });
});

// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const contractorsModule = {
    showCoiReqDialog,
    newPartner,
    removeNewPartner,
    validateUploadedFile,
    loadCertificate,
    showContactDeleteConfirmation,
    deletePolicy,
    policyDelete,
    deleteContractor,
    sendReminder,
    sendReminderConfirmation,
    addDatePicker,
    emptyDatePicker,
    addNewPolicy,
    addnewpolicytype,
    addnewpolicytypeonedit,
    changeContractorStatus,
    validatePartnerCreationForm,
    validateTenantCreationForm,
    validatePhone,
    validateEmail,
    confirmSubscriptionUpdate,
    submitPartnerCreationForm,
    submitTanentCreationForm,
    validatePartnerEditForm,
    certificateDragDrop,
    validateCertfile,
    uploadCertificate,
    deleteCert,
    confirmCert,
    expired_value,
    delete_policy_modal,
    delete_policy,
    delete_policy_add,
    editContractorAuditWizard,
    policies,
    activehover,
    activeUnhover,
    inactivehover,
    inactiveUnhover,
    edit_contractor_info,
    savePartnerInfo,
    cancelPartnerInfo,
    validateName,
    edit_insurance_info,
    saveProducerInfo,
    cancelProducerInfo,
    confirmCert1,
    save_policy,
    active_policy_modal,
    delete_active_policy,
    delete_modal,
    deleteCertificate,
    closeModel,
    show_eyeball,
    hide_eyeball,
    addingslash,
    closeEditContractor,
    close_edit,
    dropdown_policies,
    cancel_cert,
    cancel_modal,
    add_policy,
    open_delete_policy_modal,
    sumbit_filter_form,
    delete_contractor,
    delete_partner,
    edit_policies,
    save_edit_policy,
    policies_form,
    toggleOrgList,
};
